import controller from './mail-viewer.controller';
import template from './mail-viewer.html';
import './mail-viewer.scss';

export default {
	template,
	bindings: {
		data:    '<ngModel',
		type:    '<',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
